<template>
  <modal-base
      v-if="farmacloudMigrationUrl"
      :showX="false"
      v-model="openModal"
    >
    <div class="text-center">
      <img :src="iconMigration"/>
      <h2>{{ $t('FarmacloudMigrationModal.title') }}</h2>
      <button-typo class="subtitle">{{ $t('FarmacloudMigrationModal.subtitle') }}</button-typo>
      <div class="description">{{ $t('FarmacloudMigrationModal.description') }}</div>
      <b-button class="cta" :href="logoutMigration()">{{ $t('FarmacloudMigrationModal.button') }}</b-button>
    </div>
   </modal-base>
</template>
<script setup>
import { ref } from 'vue'
import iconMigration from '@/assets/img/icon-migration-farmalcoud.png'
import { URLS } from '@/dashboards'

const props = defineProps({
  farmacloudMigrationUrl: {
    type: String
  }
})

const openModal = ref(true)
function logoutMigration () {
  return `${URLS.APPS_LOGOUT_URL}?r=${encodeURIComponent(props.farmacloudMigrationUrl)}`
}
</script>
<style lang="scss" scoped>
@import 'frontendcommon-3/src/scss/config';
  img{
    margin-bottom: 30px;
  }
  h2{
    margin-bottom: 22px;
    display: block;
  }
  .subtitle{
    margin-bottom: 30px;
    display: inline-block;
  }
  .description{
    border: 1px solid $brand-01;
    background: $brand-01-soft;
    border-radius: 6px;
    padding: 12px 22px;
    max-width: 400px;
    margin: 0 auto;
    margin-bottom: 70px;
  }
</style>
